import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
// import swal from "sweetalert";
import Userdashboard from '../../Pages/Userdashboard/Userdashboard'
import PaymentService from '../../Api/services/PaymentService';
import moment from 'moment';
import { useTranslation } from "react-i18next";
import { NumericFormat } from 'react-number-format';
const AccountingList = () => {
    const { i18n, t } = useTranslation();
    const [Error, setError] = useState('');
    const [buttonText, setButtonText] = useState('Cancel');
    const [refundText, setRefundText] = useState('Refund');
    const [AccountList, setAccountList] = useState([]);
    const [packages, setpackages] = useState([]);
    const [cancaletions, setcancaletions] = useState([]);
    const [services, setservices] = useState([]);
    const [accessories, setaccessories] = useState([]);
    const [packageAmnt, setpackageAmnt] = useState([]);
    const [kilometer, setkilometer] = useState([]);
    const [monthlyBreakdowns, setMonthlyBreakdowns] = useState([]);
    const [expandedRows, setExpandedRows] = useState({});
    const [currentPage, setCurrentPage] = useState(1);
    const recordsPage = 5000000;
    const lastIndex = currentPage * recordsPage;
    const firstIndex = lastIndex - recordsPage;
    const records = AccountList.slice(firstIndex, lastIndex);
    const npage = Math.ceil(AccountList.length / recordsPage)
    const number = [...Array(npage + 1).keys()].slice(1)
    const navigate = useNavigate();

    const toggleRow = (index) => {
        setExpandedRows(prev => ({ ...prev, [index]: !prev[index] }));
    };

    function prePage() {
        if (currentPage !== 1) {
            setCurrentPage(currentPage - 1)
        }
    }
    function changeCPage(id) {
        setCurrentPage(id);
    }
    function nextPage() {
        if (currentPage !== npage) {
            setCurrentPage(currentPage + 1)
        }
    }


    const getAccountList = async () => {

        try {

            let responseData = await PaymentService.index().json()
            setAccountList(responseData.data)
            setpackages(responseData.packages)
            setkilometer(responseData.kilometer)
            setcancaletions(responseData.cancaletions)
            setservices(responseData.services)
            setaccessories(responseData.accessories)
            setpackageAmnt(responseData.packageamount)
            // Store monthly breakdown if returned by backend
            if (responseData.monthly_breakdown) {
                setMonthlyBreakdowns(responseData.monthly_breakdown);
            }
        } catch (error) {
            if (error.name === 'HTTPError') {
                const errorJson = await error.response.json();

                setError(errorJson.message)
            }
        }
    }
    useEffect(() => {
        if (localStorage.getItem('usertoken')) {

            getAccountList();

        }
        else {
            navigate('/');
        }

    }, [])

    const handleCancle = async (e) => {
        e.preventDefault();
        let order_id = AccountList[0].order_id
        console.log(order_id)
        try {
            var userData = {
                "orderid": order_id,
            }
            let responseData = await PaymentService.cancle(userData).json()
            if (responseData.status === true) {
                setButtonText('Cancelled')
                alert(responseData.msg)
            } else {
                setButtonText('Cancel')
                alert("your Order is Safe")
            }
            getAccountList();
        } catch (error) {
            if (error.name === 'HTTPError') {
                const errorJson = await error.response.json();
                setError(errorJson.message.substr(0, errorJson.message.lastIndexOf(".")))
            }
        }
    }
    const onSubmitForm = async (event) => {
        /*event.preventDefault();
        setError("");
        try {
          console.log("test");
          var userData = {
            firstName: event.target.firstName.value,
            camper_id: event.target.camper_id.value,
            email: event.target.email.value,
            phone: event.target.phone.value,
            reasonRequest: event.target.reasonRequest.value,
            order_id: inputBox
              ? event.target.order_id.value
                ? event.target.order_id.value
                : ""
              : "",
            message: event.target.message.value,
          };
    
          let responseData = await ContactService.store(userData).json();
          if (responseData.status === true) {
            // console.log(responseData)
            // alert("Form Submitted Successfully!!");
            event.target.reset();
            // navigate("/contactus");
            setisFormSubmit(true);
          }
        } catch (error) {
          console.log(error);
          if (error.name === "HTTPError") {
            const errorJson = await error.response.json();
            setError(
              errorJson.message.substr(0, errorJson.message.lastIndexOf("."))
            );
          }
        }*/
    };
    const handleRefund = async (e) => {
        e.preventDefault();
        let payment_id = AccountList[0].payment_id


        try {
            var userData = {
                "paymentid": payment_id,
            }
            let responseData = await PaymentService.refund(userData).json()
            console.log(responseData)
            if (responseData.status === true) {
                setRefundText('Refunded')
                alert(responseData.msg)
            } else {
                setButtonText('Refund')
                alert("your Order is Safe")
            }
            getAccountList();
        } catch (error) {
            if (error.name === 'HTTPError') {
                const errorJson = await error.response.json();
                setError(errorJson.message.substr(0, errorJson.message.lastIndexOf(".")))
            }
        }
    }
    return (
        <>
            <Userdashboard />
            <div className='userdashboard-content bg-off-white'>
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-xl-12">
                            <div className="card">
                                <div className="card-body p-0">
                                    <div className="table-responsive active-projects style-1 ItemsCheckboxSec shorting">
                                        <div className="tbl-caption d-flex justify-content-between text-wrap align-items-center">
                                            <h2 className="heading mb-0 text-lg">{t("Login.Booking Overview")}</h2>

                                        </div>
                                        <div className="mt-12 mb-12 relative flex flex-col bg-clip-border rounded-xl bg-white text-gray-700 shadow-md h-full w-full overflow-auto">
                                            <table id="empoloyees-tblwrapper" className="table ItemsCheckboxSec dataTable no-footer mb-0 table-auto w-full min-w-max table-auto text-left">
                                                <thead>
                                                    <tr style={{ textAlign: 'center' }}>
                                                        <th className="border-b border-blue-gray-100 bg-blue-gray-50 p-4">
                                                            <strong>{t("Login.No")}.</strong>
                                                        </th>
                                                        <th className="border-b border-blue-gray-100 bg-blue-gray-50 p-4">
                                                            <strong>{t("Login.Booking Number")}</strong>
                                                        </th>
                                                        <th className="border-b border-blue-gray-100 bg-blue-gray-50 p-4">
                                                            <strong>{t("Login.Camper Model")}</strong>
                                                        </th>
                                                        <th className="border-b border-blue-gray-100 bg-blue-gray-50 p-4">
                                                            <strong>{t("Login.Main Renter")}</strong>
                                                        </th>
                                                        <th className="border-b border-blue-gray-100 bg-blue-gray-50 p-4">
                                                            <strong>{t("Login.Services")}</strong>
                                                        </th>
                                                        <th className="border-b border-blue-gray-100 bg-blue-gray-50 p-4">
                                                            <strong>{t("Login.Accessories")}</strong>
                                                        </th>
                                                        <th className="border-b border-blue-gray-100 bg-blue-gray-50 p-4">
                                                            <strong>{t("Rent.Kilometer")}</strong>
                                                        </th>
                                                        <th className="border-b border-blue-gray-100 bg-blue-gray-50 p-4">
                                                            <strong>{t("Login.Deposit")}</strong>
                                                        </th>
                                                        <th className="border-b border-blue-gray-100 bg-blue-gray-50 p-4">
                                                            <strong>{t("Login.Total Price")}</strong>
                                                        </th>
                                                        <th className="border-b border-blue-gray-100 bg-blue-gray-50 p-4">
                                                            <strong>{t("Login.Packages")}</strong>
                                                        </th>
                                                        <th className="border-b border-blue-gray-100 bg-blue-gray-50 p-4">
                                                            <strong>{t("Login.Cancellation Polices")}</strong>
                                                        </th>

                                                        <th className="border-b border-blue-gray-100 bg-blue-gray-50 p-4">
                                                            <strong>{t("Login.Pick-Up")}</strong>
                                                        </th>
                                                        <th className="border-b border-blue-gray-100 bg-blue-gray-50 p-4">
                                                            <strong>{t("Login.Return")}</strong>
                                                        </th>
                                                        <th className="border-b border-blue-gray-100 bg-blue-gray-50 p-4">
                                                            <strong>{t("Login.Payment status")}</strong>
                                                        </th>
                                                    </tr>
                                                </thead>
                                                <tbody>

                                                    {
                                                        records.map((element, index) => {

                                                            return (
                                                                <tr style={{ textAlign: 'center' }}>
                                                                    <td className='p-4 border-b border-blue-gray-50'>
                                                                        {index + 1}
                                                                    </td>
                                                                    <td className='p-4 border-b border-blue-gray-50'> {element.payment_order_id}</td>
                                                                    <td className='p-4 border-b border-blue-gray-50'>{element.camper_name}</td>
                                                                    <td className='p-4 border-b border-blue-gray-50'>{element.full_name}</td>
                                                                    <td className='p-4 border-b border-blue-gray-50'>{services[index]}</td>
                                                                    <td className='p-4 border-b border-blue-gray-50'>{accessories[index]}</td>
                                                                    {/* Kilometer */}
                                                                    <td className='p-4 border-b border-blue-gray-50'>{kilometer[index]}</td>
                                                                    <td className='p-4 border-b border-blue-gray-50'>{packageAmnt[index]}</td>
                                                                    {/* Price column: shows Total Price by default; expands to per-month breakdown */}
                                                                    <td className='p-4 border-b border-blue-gray-50'>
                                                                        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '8px' }}>
                                                                            <span className="font-bold price-font">
                                                                                <NumericFormat
                                                                                    value={element.billing_amount}
                                                                                    thousandSeparator="."
                                                                                    decimalSeparator=","
                                                                                    displayType="text"
                                                                                />€
                                                                            </span>
                                                                            {/* Info toggle button */}
                                                                            <button
                                                                                type="button"
                                                                                title={expandedRows[index] ? t("Login.Hide breakdown") : t("Login.Show breakdown")}
                                                                                onClick={() => toggleRow(index)}
                                                                                style={{
                                                                                    background: 'none', border: 'none', cursor: 'pointer',
                                                                                    display: 'inline-flex', alignItems: 'center',
                                                                                    color: expandedRows[index] ? '#163435' : '#888'
                                                                                }}
                                                                            >
                                                                                <svg className="w-5 h-5" width="20" height="20" viewBox="0 0 32 32">
                                                                                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" fill="none" id="icon-info">
                                                                                        <path fillRule="evenodd" clipRule="evenodd" d="M15.0951 12.6199C14.3751 12.6199 13.6671 12.6199 12.9543 12.6199C12.7986 12.6213 12.6437 12.6431 12.4935 12.6847C12.3103 12.7229 12.1704 12.8715 12.1432 13.0567C12.0925 13.2579 12.1937 13.4664 12.3831 13.551C12.6138 13.6589 12.8615 13.7255 13.1151 13.7478C13.7823 13.779 14.0511 14.0718 13.9503 14.7582C13.7631 16.0422 13.5111 17.3166 13.2951 18.5982C13.1487 19.4621 13.0263 20.3285 12.8847 21.1925C12.6951 22.3565 13.7799 23.4485 14.6415 23.5925C15.1519 23.664 15.667 23.6969 16.1823 23.6909C17.2866 23.6895 18.3415 23.2328 19.0982 22.4285C19.2357 22.3019 19.3389 22.1425 19.3982 21.9653C19.4272 21.8105 19.3907 21.6506 19.2974 21.5237C19.1847 21.4531 19.0459 21.4381 18.9206 21.4829C18.7238 21.5477 18.5486 21.6821 18.3567 21.7661C18.1323 21.8708 17.8973 21.9513 17.6559 22.0061C17.4611 22.0539 17.2552 22.0138 17.0926 21.8965C16.93 21.7792 16.8271 21.5964 16.8111 21.3965C16.7707 21.1732 16.7634 20.9452 16.7895 20.7197C16.8711 20.1629 16.9863 19.6109 17.0871 19.059C17.3607 17.5534 17.6383 16.047 17.9199 14.5398C17.9967 14.127 18.1263 13.7214 18.0399 13.287C18.0264 13.0941 17.936 12.9146 17.7888 12.7891C17.6416 12.6636 17.4501 12.6026 17.2575 12.6199C16.5375 12.6199 15.8151 12.6199 15.0951 12.6199ZM16.4007 7.28235C15.5158 7.24354 14.6954 7.7442 14.3254 8.54893C13.9553 9.35365 14.1091 10.3023 14.7145 10.9489C15.3199 11.5954 16.2564 11.8112 17.0837 11.4948C17.911 11.1783 18.4645 10.3926 18.4839 9.50711C18.5176 8.32037 17.5872 7.32888 16.4007 7.28715V7.28235Z" fill="currentColor"></path>
                                                                                    </svg>
                                                                                </svg>
                                                                            </button>
                                                                        </div>

                                                                        {/* Expanded breakdown */}
                                                                        {expandedRows[index] && (
                                                                            <div style={{
                                                                                marginTop: '8px', padding: '8px',
                                                                                background: '#f8fafc', borderRadius: '6px',
                                                                                fontSize: '13px', minWidth: '160px', textAlign: 'left'
                                                                            }}>
                                                                                {/* Total Price row */}
                                                                                <div style={{ display: 'flex', justifyContent: 'space-between', fontWeight: '700', borderBottom: '1px solid #e2e8f0', paddingBottom: '4px', marginBottom: '4px' }}>
                                                                                    <span>{i18n.resolvedLanguage === 'de' ? 'Gesamtpreis' : 'Total Price'}</span>
                                                                                    <span className="price-font">
                                                                                        <NumericFormat value={element.billing_amount} thousandSeparator="." decimalSeparator="," displayType="text" />€
                                                                                    </span>
                                                                                </div>
                                                                                {/* Per-month breakdown if available from backend */}
                                                                                {monthlyBreakdowns[index] && Array.isArray(monthlyBreakdowns[index]) && monthlyBreakdowns[index].length > 0 ? (
                                                                                    monthlyBreakdowns[index].map((month, mIdx) => (
                                                                                        <div key={mIdx} style={{ display: 'flex', justifyContent: 'space-between', padding: '2px 0' }}>
                                                                                            <span>{mIdx + 1}. {i18n.resolvedLanguage === 'de' ? 'Monat' : 'Month'}</span>
                                                                                            <span className="price-font">
                                                                                                <NumericFormat value={month.price ?? month} thousandSeparator="." decimalSeparator="," displayType="text" />€
                                                                                            </span>
                                                                                        </div>
                                                                                    ))
                                                                                ) : (
                                                                                    <div style={{ color: '#94a3b8', fontSize: '11px', marginTop: '4px' }}>
                                                                                        {i18n.resolvedLanguage === 'de' ? 'Monatliche Aufschlüsselung nicht verfügbar' : 'Monthly breakdown not available'}
                                                                                    </div>
                                                                                )}
                                                                            </div>
                                                                        )}
                                                                    </td>
                                                                    <td className='p-4 border-b border-blue-gray-50'>{packages[index]}</td>
                                                                    <td className='p-4 border-b border-blue-gray-50'>{cancaletions[index]}</td>

                                                                    <td className='p-4 border-b border-blue-gray-50'>{moment(element.start_date).format('DD.MM.YYYY - HH:mm')}</td>
                                                                    <td className='p-4 border-b border-blue-gray-50'>{moment(element.end_date).format('DD.MM.YYYY - HH:mm')}</td>
                                                                    {/* <td  className='p-4 border-b border-blue-gray-50'>{element.is_paid==1?t("Rent.Paid"):t("Rent.Not Paid")}</td> */}
                                                                    <td className='p-4 border-b border-blue-gray-50'>
                                                                        {
                                                                            element.is_paid === 1 ?
                                                                                t("Rent.Fully Paid.")
                                                                                : element.is_paid === 0 ?
                                                                                    t("Rent.Not Paid.") :
                                                                                    element.is_paid === 2 ?
                                                                                        t("Rent.Partially Paid.")
                                                                                        :
                                                                                        element.is_paid === 3 ?
                                                                                            t("Rent.Fully Paid.")
                                                                                            : ""
                                                                        }
                                                                    </td>
                                                                </tr>
                                                            )
                                                        })
                                                    }

                                                </tbody>

                                            </table>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>


        </>
    );
};

export default AccountingList;
